import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackLinkClickToDealerPageEventData } from './legacy-types';
import { useLegacyTrackShownInterest } from './useLegacyTrackShownInterest';
import { mapElasticVehicleToLegacyItem } from './utils';

export const createLegacyTrackLinkClickToDealerPage = (
  market: Market,
  vehicle: ElasticVehicle,
): LegacyTrackLinkClickToDealerPageEventData => {
  const eventData: LegacyTrackLinkClickToDealerPageEventData = {
    eventType: 'microConversion',
    conversionType: 'linkClickToDealerPage',
    item: mapElasticVehicleToLegacyItem(market, vehicle),
    pageType: 'product page',
  };

  return eventData;
};

export const useLegacyTrackLinkClickToDealerPage = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();
  const { trackLegacyShownInterest } = useLegacyTrackShownInterest();

  const trackLegacyLinkClickToDealerPage = useCallback(
    (vehicle: ElasticVehicle) => {
      trackLegacyShownInterest(vehicle);
      track({
        event: 'microConversion',
        data: createLegacyTrackLinkClickToDealerPage(market, vehicle),
      });
    },
    [market, track],
  );

  return {
    trackLegacyLinkClickToDealerPage,
  };
};
